export default __webpack_public_path__ + "static/media/0346.4229b530.jpg";